module.exports = __webpack_public_path__ + "media/customizations/sunbridge/logo-c579068a7a9732be4b389a53daa3a7aa.png";